import { Injectable } from '@angular/core';
import { UserResource } from 'app/models/UserResource';

@Injectable()
export class Globals {
        userProfile : UserResource;
        psActiveModule:boolean = true;
}
